module.exports = __webpack_public_path__ + "img/glass_of_water_and_some_ice_cubes-wallpaper-1440x900.24b0a430.jpg";